import { IAppState } from '../../redux';
import { EPublishTermsStatus } from '../../redux/reducers';

export function selectPublishTermsStatus(state: IAppState): EPublishTermsStatus {
  const {
    publishTerms: { status },
  } = state;

  return status;
}
